import React from "react";
import clsx from "clsx";

const SemiNarrowContainer = ({ children, className }) => {
    return (
        <div
            className={clsx(
                "grid grid-cols-8 sm:grid-cols-12",
                "gap-x-4 sm:gap-x-6 lg:gap-x-8",
                "px-4 sm:px-0",
                "mx-auto",
                "max-w-1600px",
                className
            )}
        >
            <div className="
                col-span-8 col-start-1 
                sm:col-start-2 sm:col-end-12
                lg:col-start-3 lg:col-end-11
            ">
                {children}
            </div>
        </div>
    );
};

export default SemiNarrowContainer;